import { Translate } from 'react-redux-i18n'
import { Element } from '../../html/element'
import './i18n'

export const AllPriceIncludeVATText = () => {
  return (
    <div className="mt2 fstItalic">
      <Element elementName="span" style={{ color: '#E0505B' }}>
        *
      </Element>
      &nbsp;
      <Translate value="common.order.allPriceIncludeVATText.ALL_PRICE_INCLUDE_VAT" />
    </div>
  )
}
